export class AllowedImportField {
  field: string;
  label: string;
  group?: string;
  defaultHeader: string;
}
